export const realEstatePracticeIntro = [
  {
    title: "¿Qué es el contrato de tokenización inmobiliaria y cómo se utiliza en esta práctica?",
    value: `
El **contrato de tokenización inmobiliaria** es el documento legal y técnico que reúne toda la información esencial sobre el activo (por ejemplo, una casa en renta) que vas a representar y dividir digitalmente mediante tokens en la blockchain.

En esta práctica, trabajarás con el **ejemplo de contrato que descargaste en PDF** ([Real-estate+Asset+Contract+Example.pdf](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/Real-estate+Asset+Contract+Example.pdf)).  
Este contrato contiene todos los **campos clave** (como los que ya viste en la sección anterior), desde la descripción del inmueble y sus datos registrales, hasta los valores técnicos para tu token ERC20, como nombre, símbolo y distribución total.

**¿Qué función cumple este contrato en la tokenización?**
- **Documenta y certifica** que existe un activo real, su valor, ubicación, ingresos, propietarios, seguro, títulos y demás datos verificables.
- **Sirve de referencia directa**: todos los datos técnicos y legales se usan para rellenar tu smart contract y para que los futuros inversionistas, compradores o autoridades puedan revisar y auditar el proyecto.
- **Estructura la emisión del token**: desde el nombre (ejemplo: MyRealToken), porcentaje que representa cada token, cantidad total emitida, hasta reglas de dividendos y derechos de voto.
- **Aumenta la confianza y la transparencia**: al adjuntar enlaces, certificados, imágenes o perfiles del propietario, cualquier persona puede validar que el activo y la tokenización son legítimos.

**Importante:**  
Antes de programar y desplegar tu contrato inteligente, debes tener este documento completado y revisado.  
Así, podrás copiar los valores exactos de cada campo y pegarlos en tu smart contract ERC20, asegurando que la información digital coincide con la documentación legal y física de tu activo.

---

> **Referencia:**  
Los campos y valores a documentar (como descripción, título de propiedad, valor actual, seguro, perfil del propietario, etc.) están explicados con detalle en la sección anterior y reflejados en el PDF de ejemplo.

Este es el **primer paso para una tokenización profesional y segura** en blockchain.
`
  }
];

export default realEstatePracticeIntro;
